import { atom, useAtomValue, useSetAtom } from "jotai";
import { useReactFlow } from "@xyflow/react";
import { canvasIdAtom, edgesAtom, nodesAtom } from "@zapier/canvas-state";
import { CopilotProvider, useConversationId } from "@zapier/ai-toolkit/client";
import {
  toolsAtom,
  onToolCallAtom,
  getBodyCommand,
  getRegistryAtom,
  profileAtom,
} from "@zapier/copilot-tools";

import { initialMessagesAtom } from "./initialMessagesAtom";
import { useSubmitAndWait } from "./useSubmitAndWait";

export function CanvasCopilotHydrator({
  children,
}: {
  children: React.ReactNode;
}) {
  const initialMessages = useAtomValue(initialMessagesAtom);
  const conversationId = useConversationId();
  const onToolCall = useSetAtom(onToolCallAtom);
  const reactFlowInstance = useReactFlow();
  const registry = useAtomValue(getRegistryAtom);
  const submitAndWait = useSubmitAndWait({
    api: "/api/zsl/v2/combined_stream",
    onError: (error: string) => console.error("Error:", error),
  });
  const profile = useAtomValue(profileAtom);
  const tools = useAtomValue(toolsAtom);
  const getBody = useSetAtom(getBodyCommand);
  const getHandoffData = useSetAtom(getHandoffDataAtomCommand);

  return (
    <CopilotProvider
      profile={profile}
      loadMessagesEndpoint="/api/canvasui/chat"
      api="/api/canvasui/chat/completionsv2"
      getHandoffData={getHandoffData}
      clientTools={tools}
      onToolCall={({ toolCall }) =>
        onToolCall({
          toolCall,
          conversationId,
          reactFlowInstance,
          submitAndWait,
        })
      }
      copilotId={"canvas"}
      registry={registry}
      isExperimentalTodoListEnabled={true}
      initialConversationId={conversationId}
      maxSteps={10}
      getBody={getBody}
      initialMessages={initialMessages}
      onError={(error: any) => {
        console.error("Canvas copilot error:", error);
      }}
    >
      {children}
    </CopilotProvider>
  );
}
const getHandoffDataAtomCommand = atom(null, (get) => {
  const nodes = get(nodesAtom);
  const canvasId = get(canvasIdAtom);
  const edges = get(edgesAtom);
  return {
    nodes,
    edges,
    canvasId,
  };
});
getHandoffDataAtomCommand.debugLabel = "getHandoffDataAtomCommand";
